var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.9095 26.5453C46.9095 30.4544 46.4711 33.9292 45.5943 37.8383C44.279 43.4848 40.3333 47.394 34.6342 48.6969C27.1812 50.4344 19.29 50.4344 11.837 48.6969C6.5761 47.394 2.19203 43.0504 1.31522 37.8383C0.438399 33.9292 0 30.0201 0 26.5453C0 22.6362 0.438399 19.1613 1.31522 15.2522C2.63044 9.60572 6.5761 5.69659 12.2754 4.39355C15.7827 3.52485 19.7284 3.09052 23.6739 3.09052C27.6196 3.09052 31.1269 3.52485 35.0726 4.39355C40.7718 5.69659 44.7174 9.60572 46.0327 15.2522C46.4711 18.727 46.9095 22.6362 46.9095 26.5453Z",
    fill: "#80ADFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6315 24.2826C45.337 24.2826 50.7728 18.8467 50.7728 12.1413C50.7728 5.43584 45.337 0 38.6315 0C31.9261 0 26.4902 5.43584 26.4902 12.1413C26.4902 18.8467 31.9261 24.2826 38.6315 24.2826Z",
    fill: "#005AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyIcon);
export default __webpack_public_path__ + "static/media/reply-icon.fbe87e281d659729f178556d56f0c083.svg";
export { ForwardRef as ReactComponent };